import { createVideosColumnDefinitions } from "../VideoTableColumns";

const videosColumnDefinitions = createVideosColumnDefinitions();

export const VIDEOS_FIXED_COLUMNS = Object.keys(videosColumnDefinitions).slice(
  0,
  2
);

export const DEFAULT_VIDEOS_VISIBLE_COLUMNS = Object.keys(
  videosColumnDefinitions
).filter((key) => !VIDEOS_FIXED_COLUMNS.includes(key));

export const videosColumnOptions = Object.values(videosColumnDefinitions)
  .filter(({ key }) => !VIDEOS_FIXED_COLUMNS.includes(key))
  .map(({ key, label }) => ({ text: label, value: key }));
